export default __webpack_public_path__ + "static/media/email-verified.f43dafb1.svg";